import React from 'react';
import { Link } from '@mui/material';
import OpenInNew from '@mui/icons-material/OpenInNew';
import { FitbitExtractionJob } from '../../../services/fitbitExtractionService';

export default function FitbitExtractionCloudLink({ job }: { job: FitbitExtractionJob }) {
  if (job.kind === 'batch' || job.state !== 'completed' || !job.cloudFileUrl) return null;
  let url: URL;
  try { url = new URL(job.cloudFileUrl); } catch { return null; }
  if (url.origin !== 'https://console.cloud.google.com' || url.username || url.password ||
      !/^\/storage\/browser\/_details\/[^/]+\/.+/.test(url.pathname)) return null;
  return <Link href={url.href} target="_blank" rel="noopener noreferrer" underline="hover" variant="body2"
    sx={{ display: 'inline-flex', alignItems: 'center', gap: .75, minHeight: 36, borderRadius: 1,
      '&:focus-visible': { outline: '2px solid', outlineColor: 'primary.main', outlineOffset: 2 } }}>
    Open in Google Cloud <OpenInNew sx={{ fontSize: 16 }} />
  </Link>;
}
